import { createContext, ReactNode, memo } from 'react';
import type { ChatStepTimerStoreRef } from './ChatStepTimerStore';

export const ChatStepTimerContext = createContext<ChatStepTimerStoreRef | undefined>(undefined);

export type ChatStepTimerContextProviderProps = {
  children: ReactNode;
  storeRef: ChatStepTimerStoreRef;
};

/**
 * Context provider for ChatStepTimerStore
 * @example
 * const storeRef = useCreateChatStepTimerStoreFromAssignment(assignment)
 * <ChatStepTimerContextProvider storeRef={storeRef}>
 *    ...
 * </ChatStepTimerContextProvider>
 */
export const ChatStepTimerContextProvider = memo(
  ({ children, storeRef }: ChatStepTimerContextProviderProps) => (
    <ChatStepTimerContext.Provider value={storeRef}>{children}</ChatStepTimerContext.Provider>
  ),
);
